
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { getChargeCardDetail } from "@/api/api-non-name";
import { getCountryCodeList } from "@/api/api-basic";
@Component
export default class PiHairpinManage extends Vue {
  private FormData: objAny = {};

  private isMember = false
  private formInline: objAny = {
    cardPhysicalNumber: "",
    // cardSerialNumber: "",
    contactName: "",
    money: "0",
    memberType: "1",
    phoneNo: "",
    identityCardNumber: "",
    countryCode:'',
    silkScreenNumber: "",
    cardType: "3",
    times: [],
    effectiveBeginTime: "",
    effectiveEndTime: ""
  };
    // 获取电话区号
  public codeList: any = [];
  async getCodeList() {
    const res = await getCountryCodeList();
    if (res.status === this.$config.apiStatus) {
      this.codeList = res.data || [];
    }
  }



  async getChargeCardDetails (cardPhysicalNumber:string){
    const res  = await getChargeCardDetail({cardPhysicalNumber,cardSerialNumber:cardPhysicalNumber})
    if(res?.data?.length){
      const data = res.data[0]
      this.isMember = data.memberType ==1
      data.times=[data.effectiveBeginTime,data.effectiveEndTime]
      this.formInline = data
    }
  }
  mounted() {
    this.getCodeList()
    if (!this.FormData.$el) {
      this.$nextTick((): void => {
        this.FormData = this.$refs["formInline"];
      });
    }

    const data = this["$common"].get("non-real-name-card-management-item");
    this.getChargeCardDetails(data.cardPhysicalNumber)

}
